import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import './Loader.css';

class Loader extends Component {
  render() {
    const { loader } = this.props;
    return (
      <>
        {loader > 0 && (
          <div className="cs-loader">
            <div className="backgroundBlur" />
            <div className="cs-loader-inner">
              {new Array(6).fill(<label>●</label>)}
            </div>
          </div>
        )}
      </>
    );
  }
}
export default connect((state) => ({
  loader: state.loginReducer.loader,
}))(Loader);
